
import React from 'react';
import GlobalFooter from './common/GlobalFooter';

const Footer: React.FC = () => {
  return <GlobalFooter />;
};

export default Footer;
